import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-static-who-are-we',
  templateUrl: './static-who-are-we.component.html',
  styleUrls: ['./static-who-are-we.component.scss']
})
export class StaticWhoAreWeComponent implements OnInit {

  constructor() { }

  info = {
    title: 'Who Are We?',
    subTitle: 'Ketto is a Crowdfunding Platform based out of India.',
    desc: 'We believe in \'Healthcare for All\' & we\'re on a journey to make that a reality.'
  };

  floatingInfo = [
    // { id: 1, stats: '1100+', text: 'Crores funds raised', icon: 'piggy-bank-1' },
    { id: 2, stats: '72+', text: 'lakh Donors', icon: 'happy-1' },
    { id: 3, stats: '1,40,000', text: 'Lives saved & counting', icon: 'heart-1' },
    { id: 4, stats: '24x7', text: 'Expert Support Available', icon: 'customer-service-1' },
  ];

  ngOnInit() {
  }

}
